module.exports = __webpack_public_path__ + "static/blue-dragon-at-ruins-adb61f649ff2de349d3f9724f21d81a2.jpg";